<script setup lang="ts">
import { onMounted, onUpdated, ref } from "vue"

withDefaults(
    defineProps<{
        /**
         * Whether to stretch the tab items to fill the available space. Default is to align tabs to the left.
         */
        stretch?: boolean
        layout?: "skewed" | "tabs"
    }>(),
    {
        stretch: false,
        layout: "skewed",
    },
)

const barRef = ref<HTMLElement>()

const updateTabHeight = () => {
    if (barRef.value) {
        const maxHeight = Math.max(
            ...Array.from(barRef.value.querySelectorAll(".varsity-tab-link")).map(
                el => (el as HTMLElement).offsetHeight,
            ),
        )
        barRef.value.style.setProperty("--tab-height", `${maxHeight}px`)
    }
}

onMounted(updateTabHeight)
onUpdated(updateTabHeight)
</script>

<template>
    <div ref="barRef" :class="['varsity-tabs', `varsity-tabs--${layout}`, { 'varsity-tabs--stretch': stretch }]">
        <slot />
    </div>
</template>
